import React from 'react';
import { StyleSheet, View } from 'react-native';

import { cohortCellHeight } from '../../constants';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    height: cohortCellHeight,
  },
});

export const CohortCellSpacer: React.FC = () => {
  return <View style={styles.container} />;
};
